import { useState } from 'react'
import { Box, Card, CardBody, CardHeader, Flex, Heading } from '@chakra-ui/react'
import { UiBreadcrumb } from 'components/common'
import { DisplayPricingForm, DisplayPricingFormType } from './DisplayPricingForm'
import { createDisplayPricing } from 'api'
import { useAppContext } from 'hooks/useAppContext'
import { useNavigate } from 'react-router-dom'

const BreadcrumbNav = [
  {
    label: 'Display Pricings',
    path: '/system/display-pricings'
  },
  {
    label: 'Add',
    isCurrentPage: true
  }
]

export const AddDisplayPricing = () => {
  const navigate = useNavigate()
  const { createToast } = useAppContext()
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleAdd = async (form) => {
    setIsSubmitting(true)

    try {
      await createDisplayPricing({
        keyNo: form.keyNo,
        pitch: form.pitch,
        boardMatrix: form.boardMatrix,
        calculatedBoardMatrix: form.calculatedBoardMatrix,
        noOfLines: form.noOfLines,
        noOfCharacters: form.noOfCharacters,
        modsH: form.modsH,
        modsL: form.modsL,
        dimsH: form.dimsH,
        dimsW: form.dimsW,
        sfPrice: form.sfPrice,
        dfPrice: form.dfPrice,
        typicalAmps120: form.typicalAmps120,
        maxAmps120: form.maxAmps120,
        typicalAmps240: form.typicalAmps240,
        maxAmps240: form.maxAmps240
      })
      createToast('success', 'Display pricing created')
      navigate('/system/display-pricings')
      setIsSubmitting(false)
    } catch (err) {
      createToast('error', 'Error', err.response.data)
      setIsSubmitting(false)
    }
  }

  return (
    <>
      <UiBreadcrumb items={BreadcrumbNav} />
      <Box>
        <Flex justifyContent="space-between" alignItems="center" my={8}>
          <Heading size="lg">Add Display Pricing</Heading>
        </Flex>
        <Card borderRadius={0}>
          <CardHeader bg="gray.500" p={4}>
            <Heading color="white" size="sm">Option Information</Heading>
          </CardHeader>
          <CardBody p={8}>
            <DisplayPricingForm
              type={DisplayPricingFormType.Add}
              onSubmit={handleAdd}
              isSubmitting={isSubmitting}
            />
          </CardBody>
        </Card>
      </Box>
    </>
  )
}
